/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { InternalApiDocument } from './InternalApiDocument';
import {
    InternalApiDocumentFromJSON,
    InternalApiDocumentFromJSONTyped,
    InternalApiDocumentToJSON,
    InternalApiDocumentToJSONTyped,
} from './InternalApiDocument';

/**
 * 
 * @export
 * @interface InternalDocumentsPage
 */
export interface InternalDocumentsPage {
    /**
     * 
     * @type {number}
     * @memberof InternalDocumentsPage
     */
    number: number;
    /**
     * 
     * @type {number}
     * @memberof InternalDocumentsPage
     */
    size: number;
    /**
     * 
     * @type {number}
     * @memberof InternalDocumentsPage
     */
    total: number;
    /**
     * 
     * @type {Array<InternalApiDocument>}
     * @memberof InternalDocumentsPage
     */
    content: Array<InternalApiDocument>;
}

/**
 * Check if a given object implements the InternalDocumentsPage interface.
 */
export function instanceOfInternalDocumentsPage(value: object): value is InternalDocumentsPage {
    if (!('number' in value) || value['number'] === undefined) return false;
    if (!('size' in value) || value['size'] === undefined) return false;
    if (!('total' in value) || value['total'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    return true;
}

export function InternalDocumentsPageFromJSON(json: any): InternalDocumentsPage {
    return InternalDocumentsPageFromJSONTyped(json, false);
}

export function InternalDocumentsPageFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalDocumentsPage {
    if (json == null) {
        return json;
    }
    return {
        
        'number': json['number'],
        'size': json['size'],
        'total': json['total'],
        'content': ((json['content'] as Array<any>).map(InternalApiDocumentFromJSON)),
    };
}

export function InternalDocumentsPageToJSON(json: any): InternalDocumentsPage {
    return InternalDocumentsPageToJSONTyped(json, false);
}

export function InternalDocumentsPageToJSONTyped(value?: InternalDocumentsPage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'number': value['number'],
        'size': value['size'],
        'total': value['total'],
        'content': ((value['content'] as Array<any>).map(InternalApiDocumentToJSON)),
    };
}

